"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _AccordionContext = _interopRequireDefault(require("./AccordionContext"));
var _excluded = ["children", "eventKey", "toggleable", "as"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Accordion/AccordionCollapse.js";
var defaultProps = {
  as: 'div',
  toggleable: false
};
function AccordionCollapse(_ref) {
  var children = _ref.children,
    eventKey = _ref.eventKey,
    toggleable = _ref.toggleable,
    Comp = _ref.as,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _React$useContext = _react["default"].useContext(_AccordionContext["default"]),
    isOpen = _React$useContext.isOpen;
  return /*#__PURE__*/_react["default"].createElement(Comp, Object.assign({
    className: "collapse",
    id: eventKey.replaceAll(':', '') + '-collapse'
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 13
    }
  }), (!toggleable || isOpen) && children);
}
AccordionCollapse.defaultProps = defaultProps;
var _default = AccordionCollapse;
exports["default"] = _default;